// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".element--list{-ms-touch-action:pan-y;touch-action:pan-y}", ""]);
// Exports
module.exports = exports;
